import { render, staticRenderFns } from "./PF_Settings.vue?vue&type=template&id=2ab68e1e&scoped=true"
import script from "./PF_Settings.vue?vue&type=script&lang=js"
export * from "./PF_Settings.vue?vue&type=script&lang=js"
import style0 from "./PF_Settings.vue?vue&type=style&index=0&id=2ab68e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab68e1e",
  null
  
)

export default component.exports